import React from 'react'
import './navbar.css'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Divider, Drawer, IconButton, List, ListItem, ListItemButton, Typography, useMediaQuery } from '@mui/material';
import { Assessment, Business, Close, CloseFullscreen, Devices, Logout, Menu, People } from '@mui/icons-material';
import Cookies from 'js-cookie';
import logo from '../images/softexpresLogo.png'
import LogoutButton from './LogoutButton/LogoutButton';
//import { ThemeContext } from '../context/ThemeContext';

const Navbar = () => {
  // const {toggleTheme} = useContext(ThemeContext);
  const matches = useMediaQuery('(max-width:800px)');
  const [state, setState] = React.useState({
    top: false
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const navigate = useNavigate();

  const navs = [
    {
      name: "Users",
      url: "/users",
      icon: <People />
    },
    {
      name: "BUSINESS",
      url: "/business",
      icon: <Business />
    },
    {
      name: "Logs",
      url: "/logs",
      icon: <Assessment />
    },
  ]

  const mobileNavs = [{

    name: "Users",
    url: "/users",
    icon: <People sx={{ fontSize: 35 }} />
  },
  {
    name: "BUSINESS",
    url: "/business",
    icon: <Business sx={{ fontSize: 35 }} />
  },
  {
    name: "Logs",
    url: "/logs",
    icon: <Assessment sx={{ fontSize: 35 }} />
  },
  ]


  const list = (anchor) => (
    <Box
      className="mobile-container"
      sx={{ width: 'auto', height: "100vh" }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <IconButton onClick={toggleDrawer("top", false)} sx={{
        position: "absolute",
        top: "4px",
        right: "4px",
        border: "2px solid white"
      }}><Close sx={{ color: "white", fontSize: "30px" }} /></IconButton>
      <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"} sx={{ p: 2, gap: "40px", height: "100vh", color: "white" }}>
        {
          mobileNavs.map((el) => {
            return (
              <div key={el.name} className='nav-item-mobile' onClick={() => navigate(el.url)}>
                {el.icon}
                <span style={{ fontSize: 30 }}>{el.name}</span>
              </div>
            )
          })
        }
        <LogoutButton />
      </Box>
    </Box>
  );

  return (
    <Box sx={{ position: "sticky", top: 0, zIndex: 100 }}>
      <div className='nav-container'>
          <div style={{ padding: "12px",marginLeft:"48px", display: "flex", alignItems: "center", gap: "16px", cursor: "pointer" }} onClick={() => navigate("/home")}>
            <img src={logo} height={40} width={40} />
            <span style={{ fontSize: 25,fontWeight:500 }}> Softexpres</span>
        </div>
        {
          matches ?
            <>
              <Button onClick={toggleDrawer("top", true)}><IconButton>
                <Menu />
              </IconButton></Button>
              <Drawer
                xs={{ height: "100vh" }}
                anchor={"top"}
                open={state["top"]}
                onClose={toggleDrawer("top", false)}
              >
                {list("top")}
              </Drawer>
            </> 
            :
            <div className='nav-group'>
              <ul className="nav-links">
                {
                  navs.map((el) => {
                    return (
                      <li className="forward" kry={el.name}>
                        <div className='nav-item' onClick={() => navigate(el.url)}>
                          {el.icon}
                          <span style={{ fontSize: 18 }}>{el.name}</span>
                        </div></li>
                    )
                  })
                }
              </ul>
              <LogoutButton />
            </div>
        }
      </div>
    </Box>

  )
}

export default Navbar